import React from "react";

import "./RingLoader.scss";

const RingLoader = ({
  loading = true,
  text = "loading...",
  color = "var(--color-primary)",
  textColor = "var(--color-text)",
  size = "50px",
}) => {
  return loading ? (
    <div>
      <div style={{ borderColor: color, width: size, height: size }} className="ring-loader__spinner" />
      <p style={{ color: textColor }} className={"ring-loader__text"}>
        {text}
      </p>
    </div>
  ) : null;
};

export default RingLoader;
